<template>
  <div class="calendar-page page-container">
    <section class="page-header">
      <h1>日历查询</h1>
      <p>查询工作日、双休和节假日</p>
    </section>
    <el-card class="query-panel" shadow="never">
      <el-form :inline="true" @submit.native.prevent>
        <el-form-item label="年份"><el-input-number v-model="query.year" :min="2020" :max="2099" size="small" /></el-form-item>
        <el-form-item label="月份"><el-input-number v-model="query.month" :min="1" :max="12" size="small" /></el-form-item>
        <el-form-item><el-button type="primary" size="small" :loading="loading" @click="loadCalendar">查询</el-button></el-form-item>
      </el-form>
    </el-card>
    <el-alert v-if="rangeText" :title="rangeText" type="info" :closable="false" show-icon class="range-alert" />
    <CalendarGrid :calendar="calendar" :selected-date="selectedDay && selectedDay.date" @select-day="selectedDay = $event" />
    <el-card v-if="selectedDay" shadow="never" class="day-detail">
      <strong>{{ selectedDay.date }}</strong>
      <span>{{ selectedDay.dayName || selectedDay.dayType }}</span>
    </el-card>
  </div>
</template>

<script>
import CalendarGrid from '../components/CalendarGrid.vue'
import { queryCalendar, queryCalendarRange } from '../api/calendar'

export default {
  name: 'CalendarPage',
  components: { CalendarGrid },
  data() {
    const now = new Date()
    return { query: { year: now.getFullYear(), month: now.getMonth() + 1 }, calendar: null, selectedDay: null, loading: false, calendarRange: null }
  },
  computed: {
    rangeText() {
      if (!this.calendarRange) return ''
      return this.calendarRange.hasData ? `当前可查询范围：${this.calendarRange.minYear} 年至 ${this.calendarRange.maxYear} 年` : '当前暂无已同步的日历数据'
    }
  },
  mounted() { this.loadRange(); this.loadCalendar() },
  methods: {
    async loadRange() {
      try { const { data } = await queryCalendarRange(); if (data.code === 200) this.calendarRange = data.data } catch (error) { this.calendarRange = null }
    },
    async loadCalendar() {
      this.loading = true
      this.selectedDay = null
      try {
        const { data } = await queryCalendar(this.query.year, this.query.month)
        if (data.code !== 200) throw new Error(data.message || '查询失败')
        this.calendar = data.data
      } catch (error) { this.calendar = null; this.$message.error(error.message || '查询失败') } finally { this.loading = false }
    }
  }
}
</script>

<style scoped>
.calendar-page { padding-top: 32px; padding-bottom: 80px; }
.query-panel, .day-detail { background: var(--surface); }
.query-panel { margin-top: 32px; }
.range-alert { margin: 16px 0; }
.day-detail { margin-top: 16px; }
.day-detail span { margin-left: 16px; color: var(--ink-2); }
</style>
